import { getQueryString, byClass, setStyle } from "./utils";
const years = parseInt(getQueryString("year") || 40);

function initYearsBar() {
  const barEl = byClass("years-nav-bar");
  let children = barEl.childNodes;
  for (let i = 0; i < children.length; i++) {
    if (children[i].nodeType == Node.ELEMENT_NODE) {
      let nodeYear = children[i].textContent;
      if (nodeYear == years) {
        children[i].classList.add("selected");
      } else {
        children[i].addEventListener(
          "click",
          function () {
            let hrefLink = `?year=${nodeYear}`;
            window.location.href = hrefLink;
          },
          false
        );
      }
    }
  }
  setTimeout(() => setStyle(barEl, { visibility: "visible" }), 500);
}

export { initYearsBar };
